import script from "./DeviceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceTable.vue?vue&type=script&setup=true&lang=js"

import "./DeviceTable.vue?vue&type=style&index=0&id=f54e70e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f54e70e0"]])

export default __exports__